import React, { MouseEvent, ReactNode } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from './Button';

const useStyles = makeStyles((theme) => ({
  socialButton: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.A200,
    '&:hover': {
      backgroundColor: '#f2f2f2',
      borderColor: theme.palette.grey.A200,
    },
  },
}));

interface Props {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  icon: ReactNode;
}

const SocialButton: React.FC<Props> = ({ onClick, children, icon }) => {
  const classes = useStyles();

  return (
    <Button
      empty
      onClick={onClick}
      startIcon={icon}
      doubleAngle={false}
      className={classes.socialButton}
      color="secondary"
    >
      {children}
    </Button>
  );
};

export default SocialButton;
